import type { AgentRunRecord } from "../utils/types";

type RecentFailuresPanelProps = {
  runs: AgentRunRecord[];
  onSelectRun?: (runId: string) => void;
};

const formatTime = (value: string) =>
  new Date(value).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

export const RecentFailuresPanel = ({ runs, onSelectRun }: RecentFailuresPanelProps) => (
  <section className="admin-card h-full">
    <h2 className="admin-card-title">Recent failures</h2>
    {runs.length === 0 ? (
      <p className="admin-empty">No failures in window.</p>
    ) : (
      <ul className="admin-run-list">
        {runs.map((run) => (
          <li key={run.id} className="admin-run-item">
            <button
              type="button"
              className="w-full text-left"
              onClick={() => onSelectRun?.(run.id)}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-xs font-medium text-[var(--chart-red)]">
                  {run.status}
                </span>
                <span className="text-xs text-[var(--admin-muted)]">
                  {formatTime(run.completedAt ?? run.createdAt)}
                </span>
              </div>
              <p className="mt-1 text-sm text-[var(--admin-text)] line-clamp-2">
                {run.error ?? run.inboundPreview ?? "Unknown error"}
              </p>
            </button>
          </li>
        ))}
      </ul>
    )}
  </section>
);
